<div class="space-y-4 text-center">
  <div class="space-y-1">
    <h3 class="text-2xl font-bold text-gray-900 dark:text-white/90">2FA Verification</h3>
    <p class="text-xs text-gray-500 dark:text-gray-400">
      Open your authenticator app and enter the 6-digit code to
      <span class="block">continue</span>
    </p>
  </div>

  @if (errorMessage) {
  <div
    class="rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700 dark:border-red-500/30 dark:bg-red-500/10 dark:text-red-100">
    {{ errorMessage }}
  </div>
  }

  <div class="space-y-3">
    <div class="relative mx-auto max-w-sm">
      <input #codeInput id="two-factor-code" type="text" inputmode="numeric" autocomplete="one-time-code"
        maxlength="6"
        class="absolute inset-0 w-full h-full opacity-0 cursor-text z-10 font-mono tracking-[1em]"
        [value]="code"
        (input)="code = codeInput.value.slice(0, 6)"
        [disabled]="loading" />
      <div class="flex justify-center gap-2" aria-hidden="true">
        @for (box of [0, 1, 2, 3, 4, 5]; track box) {
        <div
          class="h-9 w-9 flex items-center justify-center rounded-md border bg-white text-base font-mono font-medium transition-all duration-200 dark:bg-gray-800"
          [ngClass]="{
            'border-blue-500 ring-2 ring-blue-500/20': code.length === box,
            'border-gray-200 dark:border-gray-700': code.length !== box,
            'text-gray-900 dark:text-gray-100': code[box],
            'text-gray-300': !code[box]
          }">
          {{ code[box] }}
        </div>
        }
      </div>
    </div>
  </div>

  <app-button size="md" className="w-full max-w-sm mx-auto" (btnClick)="submit()"
    [disabled]="loading || code.length !== 6">
    @if (loading) {
    <span class="flex items-center justify-center gap-2">
      <span class="h-4 w-4 animate-spin rounded-full border-2 border-white border-t-transparent"></span>
      Verifying...
    </span>
    } @else {
    Verify
    }
  </app-button>

  <div class="space-y-3">
    <p class="text-xs text-gray-500 dark:text-gray-400">
      Codes refresh every 30 seconds in your authenticator app.
    </p>
    <button type="button" class="text-xs text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200"
      (click)="goBack()">
      ← Back to login
    </button>
  </div>
</div>